/**
 * Accordion item <uo-accordion-item-li>
 * This web component represents an accordion item.
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

@customElement( 'uo-accordion-item-li' ) // eslint-disable-line require-jsdoc
export class AutomatorAccordionItemLi extends LitElement {
	// Define style
	static styles = css`${unsafeCSS( styles )}`;

	/**
	 * Creates an instance of AutomatorAccordionItemLi.
	 */
	constructor() {
		super();
	}

	/**
	 * Renders the HTML template for the accordion item.
	 *
	 * @return {TemplateResult} The template result for rendering.
	 */
	render() {
		return html`
			<div class="item">
				<div class="item-content">
					<slot></slot>
				</div>
				<div class="item-chip">
					<slot name="chip"></slot>
				</div>
			</div>
		`;
	}
}
